// extracted by mini-css-extract-plugin
export default {"wrap":"kH-z","subtitle":"lH-z","contentWrap":"mH-z","imgWrap":"nH-z","heading":"oH-z","copy":"pH-z"};